import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function WhatIsTalentIQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const capabilities = ['Operational capability', 'Deployment readiness', 'Environmental adaptability', 'Certification & compliance alignment', 'Stress, fatigue & performance risk signals'];
  return <section ref={ref} className="w-full bg-slate-950 py-24 lg:py-32" data-id="element-298">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-299">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-300">
          {/* Left — Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.8
        }} data-id="element-301">
            <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight tracking-tight mb-4" data-id="element-302">
              TalentIQ Is Readiness Intelligence Infrastructure.
            </h2>

            <p className="text-lg text-slate-400 mb-2" data-id="element-303">
              This isn't recruiting software.
            </p>
            <p className="text-lg text-slate-400 mb-8" data-id="element-304">
              This isn't another HR platform.
            </p>

            <p className="text-sm font-mono text-tiq-purple uppercase tracking-wider mb-4" data-id="element-305">
              TalentIQ measures:
            </p>

            <ul className="space-y-3 mb-8" data-id="element-306">
              {capabilities.map((cap, i) => <motion.li key={cap} className="flex items-start gap-3" initial={{
              opacity: 0,
              x: -20
            }} animate={isInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.5,
              delay: 0.3 + i * 0.12
            }} data-id="element-307">
                  <CheckIcon className="w-5 h-5 text-tiq-green flex-shrink-0 mt-0.5" data-id="element-308" />
                  <span className="text-tiq-blue" data-id="element-309">{cap}</span>
                </motion.li>)}
            </ul>

            <p className="text-lg text-slate-300 leading-relaxed" data-id="element-310">
              So leaders stop guessing — and{' '}
              <span className="text-white font-semibold" data-id="element-311">
                start planning with certainty.
              </span>
            </p>
          </motion.div>

          {/* Right — Visual */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative flex items-center justify-center" data-id="element-312">
            <div className="relative w-[140%] -mr-20 lg:-mr-40 z-10" data-id="element-313">
              <img src="https://cdn.magicpatterns.com/uploads/63ibHPLhxEGMfaRuduQviG/TalentIQ_Investor_Deck_26.png" alt="TalentIQ Mission Dashboard in iMac" className="w-full h-auto drop-shadow-2xl scale-110" data-id="element-314" />
            </div>
            {/* Ambient glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-tiq-purple/5 blur-3xl -z-10" data-id="element-315" />
          </motion.div>
        </div>
      </div>
    </section>;
}